import { createEvent } from "library/local-events/index.mjs"

/**
 * Raised when an admin triggers a compliance scan for a Code of Practice group.
 * Payload: { codeOfPracticeId: string }
 */
export const TriggerCopScan = createEvent("TriggerCopScan")

/**
 * Raised to push document import progress messages to all browser clients.
 * Payload: { documentId: string, message: string, type: "info" | "success" | "warn" }
 */
export const CopDocumentImportProgress = createEvent("CopDocumentImportProgress")

/**
 * Raised to push scan log messages to all browser clients.
 * Payload: { codeOfPracticeId: string, message: string, type: "info" | "success" | "warn" }
 */
export const CopScanLog = createEvent("CopScanLog")
